import React from "react";
import "./Description.css";
const Description = () => {
  return (
    <div className="description">
      <h4 className="head">About</h4>
      <p>
      Pakistan's first URDU OTT platform which brings content in your language from Iranian to Turkish, from Arabic to Pakistani with the blend of original series and films.      </p>
    </div>
  );
};

export default Description;
